<template>
  <p class="control" v-if="$router.currentRoute.name === 'locations'">
    <a
      class="button button-navbar go-back-button go-back-button-space"
      @click="$router.push('/floors')"
    >
      <span class="icon">
        <i class="fas fa-arrow-left"></i>
      </span>
    </a>
  </p>
  <span class="go-back-button-space" v-else></span>
</template>

<script>
export default {
  name: "go-back-button"
};
</script>

<style scoped>
.go-back-button {
  padding-left: 5px;
  padding-right: 5px;
  color: #6b6b6b;
  background-color: white;
  border-radius: 100%;
  border: 0px;
}
.go-back-button:hover {
  color: #6b6b6b;
  background-color: #e8eaed;
}
.go-back-button-space {
  width: 36px;
}
</style>
